module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "base-router"
    }
  }, [_c('section', {
    staticClass: "base-router"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Base-Router")]), _vm._v(" "), _c('div', {
    staticClass: "sider-bar"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/baseRouter/first'
      }
    }
  }, [_vm._v("First page")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/baseRouter/second"
    }
  }, [_vm._v("Second page")])], 1), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('router-view', {
    staticClass: "view"
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-499d397a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/baseRouter.vue
// module id = 24
// module chunks = 0